import React, { useState } from 'react';

const SelectQuantity = ({ id, drawing, unit }) => {
  const [value, setValue] = useState(1000);

  return (
    <div className="row mb-6" data-widget-element="form-group">
      <div className="input-group mb-3">
        <span className="input-group-text font13" data-widget-element="label">{t('quote_builder_widget.quantity')}</span>
        <input
          type="number"
          className="form-control text-align-right"
          value={value}
          onChange={(e) => setValue(() => e.target.value)}
          data-widget-element="input"
        />
      </div>
    </div>
  );
};

export default SelectQuantity;
